import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

export const useSlotGameErrorHandler = () => {
  const [search] = useSearchParams();

  useEffect(() => {
    const errorCode = search.get('errorCode');

    if (errorCode === '6') {
      // Playtech error
      window.parent.postMessage(
        { type: 'playtechError', payload: { errorCode: '6' } },
        import.meta.env.VITE_GAME_UI_URL,
      );
    }
  }, [search]);
};
